import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c93ddc5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "shopCart d-page-bg d-flex-column" }
const _hoisted_2 = { class: "cartList d-flex-1f d-overflow" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = {
  key: 0,
  class: "desc"
}
const _hoisted_5 = {
  key: 1,
  class: "desc"
}
const _hoisted_6 = { class: "price" }
const _hoisted_7 = { class: "cart-footer d-flex" }
const _hoisted_8 = { class: "buyprice" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p1" }, "合计：", -1))
const _hoisted_10 = { class: "p2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_checkbox = _resolveComponent("van-checkbox")!
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_stepper = _resolveComponent("van-stepper")!
  const _component_van_card = _resolveComponent("van-card")!
  const _component_van_row = _resolveComponent("van-row")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_swipe_cell = _resolveComponent("van-swipe-cell")!
  const _component_app_list = _resolveComponent("app-list")!
  const _component_van_submit_bar = _resolveComponent("van-submit-bar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_app_list, {
        onLoadData: _ctx.getCartList,
        ref: "appList",
        emptyText: "你的购物车空空如也~~快去采购吧!"
      }, {
        default: _withCtx((slotProps) => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(slotProps.list, (item, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, [
              _createVNode(_component_van_swipe_cell, null, {
                right: _withCtx(() => [
                  _createVNode(_component_van_button, {
                    square: "",
                    text: "删除",
                    type: "danger",
                    class: "delete-button",
                    style: {"height":"100%"},
                    onClick: ($event: any) => (_ctx.delcard(item, index))
                  }, null, 8, ["onClick"])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_van_row, { class: "shop-wrapper" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_van_col, {
                        span: "2",
                        class: "left-box"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_van_checkbox, {
                            onClick: ($event: any) => (_ctx.chooseChange(item.id, item)),
                            value: item.id,
                            name: item,
                            modelValue: item.isChecked,
                            "onUpdate:modelValue": ($event: any) => ((item.isChecked) = $event),
                            "checked-color": "#FD5C02"
                          }, null, 8, ["onClick", "value", "name", "modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_van_col, { span: "22" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_van_card, {
                            thumb: _ctx.splitImg(item.img)
                          }, {
                            title: _withCtx(() => [
                              _createElementVNode("div", _hoisted_3, _toDisplayString(item.name), 1)
                            ]),
                            desc: _withCtx(() => [
                              (!item.standardInfo || item.standardInfo == '')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.headerHtml(item.productDescription)), 1))
                                : _createCommentVNode("", true),
                              (item.standardInfo && item.standardInfo != '')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.standardHtml(item.standardInfo)), 1))
                                : _createCommentVNode("", true)
                            ]),
                            price: _withCtx(() => [
                              _createElementVNode("div", _hoisted_6, "￥" + _toDisplayString(item.presentPrice), 1)
                            ]),
                            num: _withCtx(() => [
                              _createVNode(_component_van_stepper, {
                                modelValue: item.num,
                                "onUpdate:modelValue": ($event: any) => ((item.num) = $event),
                                onChange: ($event: any) => (_ctx.updateNum(item)),
                                integer: ""
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                            ]),
                            _: 2
                          }, 1032, ["thumb"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024)
            ]))
          }), 128))
        ]),
        _: 1
      }, 8, ["onLoadData"])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", null, [
        _createVNode(_component_van_submit_bar, {
          "button-text": "去结算",
          onSubmit: _ctx.onSubmit
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_checkbox, {
              modelValue: _ctx.selAll,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selAll) = $event)),
              "checked-color": "#FD5C02",
              onClick: _ctx.checkAll
            }, {
              default: _withCtx(() => [
                _createTextVNode("全选 ")
              ]),
              _: 1
            }, 8, ["modelValue", "onClick"]),
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("span", _hoisted_10, "¥" + _toDisplayString(_ctx.totalPrice), 1)
            ])
          ]),
          _: 1
        }, 8, ["onSubmit"])
      ])
    ])
  ]))
}